import { LayoutColumnComponent } from './components/basic/layout-column/layout-column.component';
import { LayoutContainerComponent } from './components/basic/layout-container/layout-container.component';
import { LayoutRowComponent } from './components/basic/layout-row/layout-row.component';
import { ContainerFixedDirective } from './directives/container-fixed.directive';
import { ContainerFluidDirective } from './directives/container-fluid.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Layouts = [
    LayoutContainerComponent,
    LayoutRowComponent,
    LayoutColumnComponent,
    ContainerFluidDirective,
    ContainerFixedDirective
];
